export const translations = {
  es: {
    // Navigation
    nav: {
      services: 'Servicios',
      caseStudies: 'Casos de Éxito',
      platform: 'Plataforma',
      contact: 'Contacto',
      clientPortal: 'Portal Clientes'
    },
    
    // Hero Section
    hero: {
      title: 'Analítica de Datos y Consultoría Económica',
      subtitle: 'Combinamos analítica de datos, sistemas de información geográfica y análisis económico para ayudar a nuestros clientes a tomar decisiones más informadas.',
      ctaButton: 'Ver Casos de Éxito',
      ctaSecondary: 'Conocer WONK',
      clientAccess: 'Acceso de Clientes'
    },
    
    // Services Section
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones integrales para el análisis de datos y consultoría económica',
      items: [
        {
          icon: '📊',
          title: 'Analítica de Datos y Consolidación de Bases de Datos',
          description: 'Generación de conocimiento práctico a partir de Big Data con georreferenciación de alto valor para decisiones de política pública, sectoriales y empresariales.'
        },
        {
          icon: '💼',
          title: 'Análisis Económico',
          description: 'Estimación de impacto económico y fiscal, análisis de dinámicas sectoriales, industriales y del mercado laboral.'
        },
        {
          icon: '🏛️',
          title: 'Coordinación de Políticas Públicas',
          description: 'Planes de desarrollo y competitividad, sistemas de información, políticas de desarrollo sectorial y territorial a nivel nacional y local.'
        },
        {
          icon: '📈',
          title: 'Pronósticos Económicos',
          description: 'Construcción de ejercicios de pronóstico económico para el sector privado con modelos de predicción avanzados.'
        }
      ]
    },
    
    // Case Studies Section
    caseStudies: {
      title: 'Casos de Éxito',
      subtitle: 'Proyectos que han transformado la toma de decisiones'
    },
    
    // DTA Model Section
    dtaModel: {
      title: 'Modelo DTA',
      subtitle: 'Data-driven Territorial Analysis'
    },
    
    // WONK Platform Section
    wonk: {
      title: 'WONK: Workflow Oriented Network of Knowledge',
      subtitle: 'Tu herramienta de análisis y enriquecimiento de datos',
      description: 'Plataforma inteligente que integra, organiza y analiza múltiples fuentes de información sobre dinámicas económicas y sociales locales. Facilita información detallada y continua para ayudar a los clientes a tomar decisiones informadas.',
      features: [
        {
          title: 'Integración de Múltiples Fuentes',
          description: 'Combina registros administrativos, hogares, empresas, propiedades y datos satelitales.'
        },
        {
          title: 'Análisis Georeferenciado',
          description: 'Visualización y análisis espacial de datos económicos y sociales.'
        },
        {
          title: 'Predicción Avanzada',
          description: 'Modelos de machine learning para análisis predictivo y comportamental.'
        }
      ]
    },
    
    // Contact Section
    contact: {
      title: 'Contactanos',
      subtitle: 'Estamos listos para ayudarte con tus proyectos de analítica de datos',
      form: {
        name: 'Nombre',
        email: 'Correo Electrónico',
        company: 'Empresa',
        message: 'Mensaje',
        submit: 'Enviar Mensaje'
      },
      email: 'contacto@insight-place.com',
      locations: 'Bogotá, Colombia • Cartagena, Colombia'
    },
    
    // Footer
    footer: {
      tagline: 'Transformando datos en decisiones inteligentes',
      rights: '© 2024 InsightPlace. Todos los derechos reservados.'
    },
  },
  
  en: {
    // Navigation
    nav: {
      services: 'Services',
      caseStudies: 'Case Studies',
      platform: 'Platform',
      contact: 'Contact',
      clientPortal: 'Client Portal'
    },
    
    // Hero Section
    hero: {
      title: 'Data Analytics and Economic Consulting',
      subtitle: 'We combine data analytics, geographic information systems, and economic analysis to help our clients make more informed decisions.',
      ctaButton: 'View Case Studies',
      ctaSecondary: 'Discover WONK',
      clientAccess: 'Client Access'
    },
    
    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions for data analysis and economic consulting',
      items: [
        {
          icon: '📊',
          title: 'Data Analytics & Database Consolidation',
          description: 'Generation of practical knowledge from Big Data with high-value georeferencing for public policy, sectoral, and business decisions.'
        },
        {
          icon: '💼',
          title: 'Economic Analysis',
          description: 'Estimation of economic and fiscal impact, analysis of sectoral, industrial, and labor market dynamics.'
        },
        {
          icon: '🏛️',
          title: 'Public Policy Coordination',
          description: 'Development and competitiveness plans, information systems, sectoral and territorial development policies at national and local levels.'
        },
        {
          icon: '📈',
          title: 'Economic Forecasting',
          description: 'Construction of economic forecasting exercises for the private sector with advanced prediction models.'
        }
      ]
    },
    
    // Case Studies Section
    caseStudies: {
      title: 'Case Studies',
      subtitle: 'Projects that have transformed decision-making'
    },
    
    // DTA Model Section
    dtaModel: {
      title: 'DTA Model',
      subtitle: 'Data-driven Territorial Analysis'
    },
    
    // WONK Platform Section
    wonk: {
      title: 'WONK: Workflow Oriented Network of Knowledge',
      subtitle: 'Your data analysis and enrichment tool at hand',
      description: 'Intelligent platform that integrates, organizes, and analyzes multiple sources of information on local economic and social dynamics. Provides detailed and continuous information to help clients make informed decisions.',
      features: [
        {
          title: 'Multiple Source Integration',
          description: 'Combines administrative records, households, companies, properties, and satellite data.'
        },
        {
          title: 'Georeferenced Analysis',
          description: 'Spatial visualization and analysis of economic and social data.'
        },
        {
          title: 'Advanced Prediction',
          description: 'Machine learning models for predictive and behavioral analysis.'
        }
      ]
    },
    
    // Contact Section
    contact: {
      title: 'Contact Us',
      subtitle: 'We are ready to help you with your data analytics projects',
      form: {
        name: 'Name',
        email: 'Email',
        company: 'Company',
        message: 'Message',
        submit: 'Send Message'
      },
      email: 'contacto@insight-place.com',
      locations: 'Bogotá, Colombia • Cartagena, Colombia'
    },
    
    // Footer
    footer: {
      tagline: 'Transforming data into intelligent decisions',
      rights: '© 2024 InsightPlace. All rights reserved.'
    },
  }
};